import { render, staticRenderFns } from "./UploadMaterialsExcelFromCubage.vue?vue&type=template&id=10e04046"
import script from "./UploadMaterialsExcelFromCubage.vue?vue&type=script&lang=js"
export * from "./UploadMaterialsExcelFromCubage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports